import { Section, SectionContainer } from '@components/Section';
import Img from '@components/Img';

import Styles from './Styles.module.scss';

const Item = ({ title, description, children }) => (
  <div className={Styles.item}>
    {children}
    <div className={Styles.container}>
      <h3 className={Styles.title}>{title}</h3>
      <p className={Styles.description}>{description}</p>
    </div>
  </div>
);

const ClientServiceSummary = () => {
  return (
    <SectionContainer>
      <Section
        title='Services and Customer Support'
        textColor={Section.Color.WHITE}
        subtitle='We provide fully customizable assistance to meet the needs of your organization and your project.'>
        <div className={Styles.grid}>
          <Item
            title={`Talent Sourcing`}
            description={`Your account manager will match your team to highly qualified and vetted talent, fully customized to your project requirements.`}>
            <Img src={`/img/services/talent-sourcing.svg`} height={100} width={100} />
          </Item>
          <Item
            title={`Project management`}
            description={`Experienced project managers in your vertical will help your team to plan, execute and monitor performance of large scale projects.`}>
            <Img src={`/img/services/product-managers.svg`} height={100} width={100} />
          </Item>
          <Item
            title={`Customized workflow`}
            description={`Experienced project managers in your vertical will help your team to plan, execute and monitor performance of large scale projects.`}>
            <Img src={`/img/services/workflow.svg`} height={100} width={100} />
          </Item>
          <Item
            title={`Onboarding and migration`}
            description={`Onboard new talent, migrate existing teams, and drive adoption with best practices.`}>
            <Img src={`/img/services/onboarding.svg`} height={100} width={100} />
          </Item>
        </div>
      </Section>
    </SectionContainer>
  );
};

export default ClientServiceSummary;
